module.exports = __webpack_public_path__ + "media/src/images/icons/white-funnel-1021a023fbcd6764c90b8f91cd57494c.svg";